/** Label for a variant: option values (ignoring "Default") or the variant title. */
export const variantLabel = (v: any) =>
  (v?.options ?? [])
    .map((o: any) => o.value)
    .filter((x: string) => x && x !== "Default" && x !== "Default option value")
    .join(" / ") || ((v?.options ?? []).length ? "Each" : v?.title) || "Each"

const sizeValue = (label: string) => {
  const m = /([\d.]+)\s*(kg|g|ml|l|x)?/i.exec(label || "")
  if (!m) return Number.POSITIVE_INFINITY
  const n = parseFloat(m[1])
  const unit = (m[2] || "").toLowerCase()
  return unit === "kg" || unit === "l" ? n * 1000 : n
}

/** Sort sizes small → large (by weight when present, else by the number in the label). */
export const sortVariants = <T,>(variants: T[]): T[] =>
  [...variants].sort((a: any, b: any) => {
    const wa = a?.weight ?? null
    const wb = b?.weight ?? null
    if (wa && wb && wa !== wb) return wa - wb
    return sizeValue(variantLabel(a)) - sizeValue(variantLabel(b))
  })
